import i18n from '../../i18n'

export const WeekdaysDB = () => {
  return [
    { label: i18n.t('weekdays.monday'), value: 2 },
    { label: i18n.t('weekdays.tuesday'), value: 3 },
    { label: i18n.t('weekdays.wednesday'), value: 4 },
    { label: i18n.t('weekdays.thursday'), value: 5 },
    { label: i18n.t('weekdays.friday'), value: 6 },
    { label: i18n.t('weekdays.saturday'), value: 7 },
    { label: i18n.t('weekdays.sunday'), value: 1 }
  ]
}
